import React, { useState, useEffect } from 'react'

const HeroVideo = () => {
  const [displayText, setDisplayText] = useState('')
  const [currentWordIndex, setCurrentWordIndex] = useState(0)
  const [isTyping, setIsTyping] = useState(true)
  const words = ['konstrukcji', 'wnętrz', 'ogrodów']

  useEffect(() => {
    let timeout: NodeJS.Timeout
    const currentWord = words[currentWordIndex]

    if (isTyping) {
      if (displayText.length < currentWord.length) {
        timeout = setTimeout(() => {
          setDisplayText(currentWord.slice(0, displayText.length + 1))
        }, 100)
      } else {
        timeout = setTimeout(() => {
          setIsTyping(false)
        }, 1000)
      }
    } else {
      if (displayText.length > 0) {
        timeout = setTimeout(() => {
          setDisplayText(displayText.slice(0, -1))
        }, 50)
      } else {
        setIsTyping(true)
        setCurrentWordIndex((prev) => (prev + 1) % words.length)
      }
    }

    return () => {
      if (timeout) {
        clearTimeout(timeout)
      }
    }
  }, [displayText, currentWordIndex, isTyping, words])

  return (
    <section className='tw-relative tw-w-full tw-h-screen tw-overflow-hidden'>
      <video
        className='tw-absolute tw-top-0 tw-left-0 tw-w-full tw-h-full tw-object-cover'
        autoPlay
        loop
        muted
        playsInline
      >
        <source src='assets/images/sliders/main.mov' type='video/mp4' />
        Twoja przeglądarka nie obsługuje tagu wideo.
      </video>

      <div className='tw-absolute tw-inset-0 tw-bg-black/50' />

      <div className='tw-relative tw-z-10 tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-full tw-text-center tw-px-4 sm:tw-px-6 lg:tw-px-8'>
        <h1 className='tw-text-white tw-text-3xl sm:tw-text-4xl lg:tw-text-5xl xl:tw-text-6xl tw-font-bold tw-mb-6'>
          Jedno narzędzie dla designu przestrzeni
        </h1>
        <p className='tw-text-neutral-200 tw-text-lg sm:tw-text-xl lg:tw-text-2xl tw-max-w-3xl lg:tw-max-w-4xl tw-leading-relaxed'>
          Oferty które wyglądają tak dobrze, jak Twoje projekty{' '}
          <span className='tw-text-emerald-400 tw-transition-all tw-duration-300'>
            {displayText}
            <span className='tw-animate-pulse'>|</span>
          </span>
        </p>
      </div>
    </section>
  )
}

export default HeroVideo
